export const twitchLogo: string = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.63668 0L0 4.16919V20.8439H5.99837V23.9723H9.27323L12.5448 20.8439H17.4536L24 14.5929V0H1.63668ZM3.81719 2.08327H21.8186V13.5485L17.9993 17.197H12L8.72932 20.3211V17.197H3.81719V2.08327ZM9.81797 12.5076H12V6.25467H9.81797V12.5076ZM15.8177 12.5076H17.9993V6.25467H15.8177V12.5076Z" fill="#5A3E85"/>
</svg>
`;
